import swal from 'sweetalert'

import { OPERATION, setOperation } from './handlers'
import {
  bringUserBackToStart, detectFormChanges,
  getActiveTab, noEmptyAttribute, onMouseClick, removeSelectedFeature,
  selectClick, showDoneEditingBox, titleCase, toastDestroy,
  setSelectedFeatureId, setSelectedFeatureOl
} from './helperFunctions'
import { g, lowlightId } from './map/d3Renderer'
import {
  addDrawing, drawInteraction, drawTooltip,
  removeDrawing, setCancelledDrawing, sketch
} from './map/drawing'
import {
  drawnSource, removableBorders, vectorLayer, updatedVectorLayer
} from './map/layers'
import { setMeasure, hideMeasureTooltip } from './map/measure'
import { map } from './map/tools'
import { closeMessageBox, loadingGeometry, simpleToast } from './notifications'
import {
  currentToolbarWindow, debug, highlighted,
  i18n, locallyAr5, minZoom,
  setCurrentGeoType, setCurrentToolbarWindow, setHighlighted
} from './storage'

export function moveTabToHome() {
  if (getActiveTab() === 4 && !noEmptyAttribute()) {
    swal({
      title: 'Mangler egenskaper',
      text: i18n['generic']['missing-attributes-text'],
      type: 'error',
      confirmButtonText: 'Ok'
    });
  } else { // Remove all data
    // Remove selected features
    updatedVectorLayer.getSource().clear();
    removeSelectedFeature();

    // Remove old SVG objects
    g.selectAll('path').remove();
    g.selectAll('text').remove();
    g.selectAll('circle').remove();
    g.selectAll('polyline').remove();

    // Remove all old features
    vectorLayer.getSource().clear();

    // Removed drawn features
    drawnSource.clear();

    // Remove drawing and clicking

    // Stop drawing
    removeDrawing();

    // Remove click hander
    map.removeInteraction(selectClick);

    // Remove popup on mouseover feature
    map.un('singleclick', onMouseClick);

    // Remove toasts
    toastDestroy();

    setCurrentGeoType(undefined);
    setCurrentGeoType(null);
    setHighlighted(0);
    setSelectedFeatureId(null);
    setSelectedFeatureOl(null);

    // Fix css on tabs

    // Show start card and hide all other
    $('.info-box').hide();
    $('#info-box-choose-layer').show();

    // Switch tab to tab-home
    $('.tab').addClass('disabled');
    $('#tab-home').removeClass('disabled');

    $('.tab').removeClass('blue');
    $('#tab-home').addClass('blue');

    $('.tab').find($('a')).removeClass('white-text');
    $('#tab-home').find($('a')).addClass('white-text');

    $('.tab').find($('a')).removeClass('active');
    $('#tab-home').find($('a')).addClass('active');

    // Update tabs
    $('ul.tabs').tabs();

    $('#tab-save-text').text('Oppdatere');
    loadingGeometry(false);
  }
}

export function moveTabToOperations(force) {
  // if (getActiveTab() === 4 && !noEmptyAttribute() && !force) {
  //   swal({
  //     title: 'Mangler egenskaper',
  //     text: i18n['generic']['missing-attributes-text'],
  //     type: 'error',
  //     confirmButtonText: 'Ok'
  //   });
  // } else { // Remove all data
    setOperation('none');
    // Hide regret for new features:
    showDoneEditingBox('hide');

    // Remove selected features
    updatedVectorLayer.getSource().clear();
    removeSelectedFeature();

    // Removed drawn features
    drawnSource.clear();

    // Remove drawing and clicking

    // Stop drawing
    removeDrawing();

    // Remove click hander
    map.removeInteraction(selectClick);

    // Remove toasts
    toastDestroy();

    // Show popup on mouseover feature
    map.on('singleclick', onMouseClick);

    // Fix css on tabs

    // Show start card and hide all other
    $('.info-box').hide();
    $('#info-box-choose-edit-type').show();

    // Switch tab to tab-home
    $('.tab').addClass('disabled');
    $('#tab-home').removeClass('disabled');
    $('#tab-operations').removeClass('disabled');

    $('.tab').removeClass('blue');
    $('#tab-operations').addClass('blue');

    $('.tab').find($('a')).removeClass('white-text');
    $('#tab-operations').find($('a')).addClass('white-text');

    $('.tab').find($('a')).removeClass('active');
    $('#tab-operations').find($('a')).addClass('active');

    // Update tabs
    $('ul.tabs').tabs();
  // }
}

export function moveTabToDrawPick() {
  if (getActiveTab() === 4 && !noEmptyAttribute()) {
    swal({
      title: 'Mangler egenskaper',
      text: i18n['generic']['missing-attributes-text'],
      type: 'error',
      confirmButtonText: 'Ok'
    });
  } else { // Remove all data
    // Remove selected features
    updatedVectorLayer.getSource().clear();
    removeSelectedFeature();

    // Removed drawn features
    drawnSource.clear();

    // Reset drawing
    removeDrawing();

    // Remove toasts
    toastDestroy();

    // Remove click hander
    map.removeInteraction(selectClick);

    if (OPERATION === 'edit') {
      addEditClickHandler();
    } else if (OPERATION === 'add') {
      // Go back to drawing modus
      if(CURRENT_GEOTYPE === 'point') {
        addDrawing('Point');
      } else {
        addDrawing('LineString');
      }
    }

    // Show start card and hide all other
    $('.info-box').hide();
    if (OPERATION === 'edit') { $('#info-box-text-no-action').show(); }
    else if (OPERATION === 'add') { $('#info-box-text').show(); }

    // Switch tab to tab-home
    $('.tab').addClass('disabled');
    $('#tab-home').removeClass('disabled');
    $('#tab-operations').removeClass('disabled');
    $('#tab-draw-pick').removeClass('disabled');

    $('.tab').removeClass('blue');
    $('#tab-draw-pick').addClass('blue');

    $('.tab').find($('a')).removeClass('white-text');
    $('#tab-draw-pick').find($('a')).addClass('white-text');

    $('.tab').find($('a')).removeClass('active');
    $('#tab-draw-pick').find($('a')).addClass('active');

    // Update tabs
    $('ul.tabs').tabs();
  }

}

const getCentreParameters = () => {
  const v = map.getView();
  const c = v.getCenter();
  const utm = v.getProjection().getCode();
  return `X=${c[1]}&Y=${c[0]}&epsg=${utm.split(':')[1]}&`;
};

const getBgParameter = () => {
  const currentBasemap = document.getElementsByClassName('bg-highlight')[0].id;
  const ar5web2kilden = {
    graatoner: 'graatone',
    flybilder: 'norgeibilder',
    ingen: 'ingen'
  };
  return `bgLayer=${ar5web2kilden[currentBasemap]}&`;
};

const setParametersToKilden = (event) => {
  const a = event.target;
  const topic = `topic=${locallyAr5 ? 'arealinformasjon' : 'reindrift'}&`;
  const centre = getCentreParameters();
  const v = map.getView();
  const utm35 = (v.getProjection().getCode().slice(-2) === '35');
  const kildenZoom = v.getZoom() - (utm35 ? 2 : 2.9);
  const zoom = `zoom=${kildenZoom}&`;
  const bg = getBgParameter();
  const manuskart = 'ar5_flater,ar5_usikre_flater,ar5_flater_minfo';
  const layers = `layers=${locallyAr5 ? manuskart : ''}`;
  a.search = '?' + topic + centre + zoom + bg + layers;
};

const fixCardOverflow = (e) => {
  const card = document. getElementById('velgData');;
  const revealed = (card.style.overflow === 'hidden');
  if (revealed) setTimeout(() => card.style.overflow = 'visible', 100);
};

export const fillHelpText = (ar5) => {
  const n = 'https://nibio.no';
  const ar5Url = n + '/tema/jord/arealressurser/arealressurskart-ar5/' +
    'ajourhold-av-ar5/kontinuerlig-ajourhold/kokebøker-for-kontinuerlig-ajourhold';
  const reinUrl = n + '/tjenester/kilden/veiledning-reindrift';
  const blue = ' style="color:blue"';
  const blank = ' target="_blank"';
  const href = ' href="' + (ar5 ? ar5Url : reinUrl) + '"';
  const ar5Text = '<a' + href + blue + blank + '>Brukerveiledning</a>';
  const reinText = '<a' + href + blue + blank + '>Brukerveiledning</a> \
    <br><br> \
    Faglig kontakt: <br>\
    <a href="mailto:reindriftskart@landbruksdirektoratet.no" style="color:green"> \
    reindriftskart@landbruksdirektoratet.no</a> \
    <br><br> \
    Teknisk kontakt: <br>\
    <a href="mailto:reindriftskart@nibio.no" style="color:green"> \
    reindriftskart@nibio.no</a>';
  const variableText = ar5 ? ar5Text : reinText;
  const k = 'https://kilden.nibio.no';
  const htmlText = '<br>' + variableText + '<br><br> Gå til ';
  for (let i = 0; i < 5; i++) {
    const id = (i === 0) ? 'toolbarWindowHelp' : `help${i}Content`;
    const a = document.createElement('a');
    a.innerHTML = 'Kilden';
    a.onclick = setParametersToKilden;
    a.href = ar5 ? k : k + '/?topic=reindrift';
    a.target = '_blank';
    a.style.color = 'blue';
    const h = document.getElementById(id);
    h.innerHTML = htmlText;
    h.appendChild(a);
  }
  // Fix card overflow after having clicked on help:
  document.getElementById('help1').onclick = fixCardOverflow;
  document.getElementById('velgDataRevealTitle').onclick = fixCardOverflow;
};

export const askToConfirm = (question) => new Promise((resolve, reject) => {
  // document.getElementById('question').textContent = question;
  document.getElementById('question').innerHTML = `<h5>${question}</h5>`;
  let answered = false;
  const answer = (w) => {
    answered = w;
    $('#yesNoModal').closeModal({
      complete: () => { resolve(answered); } // Callback for Modal close
    });
  };
  document.getElementById('yesToQuestion').onclick = () => { answer(true); };
  document.getElementById('noToQuestion').onclick = () => { answer(false); };
  document.getElementById('xYesNoModal').onclick = () => { answer(false); };
  // console.log(document.activeElement);
  $('#yesNoModal').openModal({
    opacity: .2, // Opacity of modal background
    // Callback for Modal close in case Esc or click outside:
    complete: () => { resolve(answered); }
  });
});

export const closeToolbarWindow = (skipOrClickEvent) => {
  const skipShow = skipOrClickEvent && (typeof skipOrClickEvent === 'string');
  // console.log('closeToolbarWindow', skipShow);
  document.getElementById('toolbarWindow').hidden = true;
  if (currentToolbarWindow !== 'draw' && !skipShow) showToolbar('none', 'skip');
  if (currentToolbarWindow === 'info') {
    hideFeatureInfo();
    lowlightId(highlighted);
  }
};

const cancelCurrentOperation = (oldTab, newTab) => new Promise((resolve, e) => {
  if (oldTab === newTab) resolve(true);
  switch (OPERATION) {
    case 'add':
      if (debug < 11) console.log('Cancel drawing?');
      const cancelDrawing = () => {
        setCancelledDrawing(true);
        if (drawInteraction) drawInteraction.finishDrawing();
        map.removeOverlay(drawTooltip);
        hideMeasureTooltip();
        deleteLastDrawnPointBtn.classList.add('hidden');
        // moveTabToOperations(); // needed to hide #info-box-text,
        // but it breaks polygon creation by showing "mangler egenskaper", then:
        document.getElementById('info-box-text').style.display = 'none';
        map.getView().setMinZoom(minZoom); // drawend is not triggered if empty draw
        // showToolbar('none');
        drawnSource.clear(); // still visible if you cannot moveTabToOperations
        // Avoid getting confirmation message again:
        setOperation(newTab);
        removeDrawing();
        if (sketch) sketch.getGeometry().setCoordinates([]);
        map.on('singleclick', onMouseClick);
      };
      const cancelDrawingAndResetTwd = () => {
        document.getElementById('twdStep1').hidden = false;
        document.getElementById('twdStep2').hidden = true;
        document.getElementById('twdStep3').hidden = true;
        cancelDrawing();
        resolve(true);
      };
      const geo = (sketch) ? sketch.getGeometry().getCoordinates() : [];
      if (geo.length > 2) { // Something has been drawn
        askToConfirm(
          'Vil du avslutte å tegne før du er ferdig? Du vil miste alt som er tegnet!'
        ).then(confirmed => {
          if (debug < 11) console.log('svar er', confirmed ? 'ja' : 'nei');
          if (confirmed) cancelDrawingAndResetTwd();
          else {
            if (debug < 11) console.log('stay');
            if (newTab === 'edit') { // cancel edit because it started
              setSelectedFeatureId(null);
              setSelectedFeatureOl(null);
              setHighlighted(0);
              showDoneEditingBox('hide');
              map.removeInteraction(selectClick);
              setOperation('add');
              map.getView().setMinZoom(minZoom);
            }
            resolve(false);
          }
        });
      } else cancelDrawingAndResetTwd();
      break;
    case 'edit':
      if (debug < 11) console.log('Cancel editing');
      const rb = document.getElementById('regretButton');
      if (rb.onclick) rb.click();
      else { // no need to set back original values on selected feature
        bringUserBackToStart();
        map.getView().setMinZoom(minZoom);
        if (detectFormChanges()) {
          simpleToast('Endring er IKKE blitt lagret', 'error');
        }
      }
      resolve(true);
      break;
    case 'edit_new':
      resolve(false); // Prevent switch during creation of new feature
      break;
    default:
      resolve(true); // No need to cancel other operations (search, info, help)
  }
});

const liftButton = (tab) => {
  const tb = document.getElementById('toolbarButtons');
  const tab2id = (tab) => {
    if (tab === 'draw') return 'geometry-change';
    if (tab === 'edit') return 'geometry-change-attributes';
    return 'toolbar_' + tab;
  };
  const toBeLifted = tab2id(tab);
  const buttons = tb.getElementsByTagName('button');
  const l = buttons.length;
  for (let i = 0; i < l; i++) {
    const b = buttons[i];
    if (b.id === toBeLifted) b.classList.add('lift');
    else b.classList.remove('lift');
  }
  if (locallyAr5 && ['draw', 'edit', 'info'].indexOf(tab) > -1) setMeasure(false);
};

export const showToolbar = (tab, skipClosing) => {
  // console.log('showToolbar:', currentToolbarWindow, '-->', tab, skipClosing);
  if (!locallyAr5) return;
  if (currentToolbarWindow === tab) {
    if (tab !== 'none') document.getElementById('toolbarWindow').hidden = false;
    return;
  }
  if (debug < 16) console.log(currentToolbarWindow, '-->', tab);
  if (debug < 11) console.log('OPERATION:', OPERATION);
  closeMessageBox();
  // // Do not change window while drawing or editing:
  // if (['add', 'edit'].indexOf(OPERATION) > -1) return;
  cancelCurrentOperation(currentToolbarWindow, tab).then(cancelled => {
    if (!cancelled) return; // There has been a change of mind by the user
    liftButton(tab);
    const map2id = (s) => 'toolbarWindow' + titleCase(s);
    const validOptions = ['search', 'draw', 'edit', 'info', 'help'];
    if (validOptions.indexOf(currentToolbarWindow) > -1) {
      document.getElementById(map2id(currentToolbarWindow)).hidden = true;
    }
    if (validOptions.indexOf(tab) > -1) {
      document.getElementById('toolbarWindow').hidden = false;
      document.getElementById(map2id(tab)).hidden = false;
    } else if (!skipClosing) closeToolbarWindow('skip showToolbar, just did');
    setCurrentToolbarWindow(tab);
  });
};

export const showFeatureInfo = (hit) => {
  if (locallyAr5) {
    if (hit) {
      document.getElementById('infoCardTitle').hidden = false;
      document.getElementById('infoCardAction').hidden = false;
    }
    // showToolbar('info');
  } else $('#info-box-popup').show();
};
export const hideFeatureInfo = () => {
  if (locallyAr5) {
    // showToolbar('none');
    document.getElementById('infoCardTitle').hidden = true;
    document.getElementById('infoCardAction').hidden = true;
    const text = document.getElementById('info-box-popup-text');
    text.innerHTML = '<p class="bb">' + i18n.surface.selectFeature + '</p>';
  } else $('#info-box-popup').hide();
};

export const showEditOptions = () => {
  $('#info-box-object-attributes').show();
  if (locallyAr5) {
    document.getElementById('tweStep1').hidden = true;
    document.getElementById('tweStep2').hidden = false;
    // showToolbar('edit');
  }
};
export const hideEditOptions = () => {
  $('#info-box-object-attributes').hide();
  if (locallyAr5) {
    document.getElementById('tweStep3').hidden = true;
    document.getElementById('tweStep2').hidden = true;
    document.getElementById('tweStep1').hidden = false;
  }
};
